import { Trans } from '@lingui/react/macro';
import { styled } from '@mui/material';

import { VideaTypography } from '../../../../common-components/elements/VideaTypography/VideaTypography';
import {
  blueBlack500,
  blueBlack640,
  green400,
  greyLight500,
} from '../../../../theme/videa-style-tokens';
import { FINE_PRINT } from '../../constants';

const LocationsContainer = styled('div')`
  position: relative;
  display: flex;
  align-items: baseline;
  margin: 1.5em 0 1em;

  .info {
    display: inline-block;
    padding: 0.125em 0.5em;
    border: 2px solid ${greyLight500};
    color: ${blueBlack500};
    border-radius: 0.25em;
    text-transform: uppercase;
    transform: translateY(-0.25em);
  }
  .title {
    color: ${blueBlack640};
    font-weight: 500;
  }
  .period {
    margin: 0 0.5em;
    font-size: 1.5em;
    font-weight: 400;
    color: ${blueBlack640};
  }
  .fine-print {
    position: absolute;
    right: 0;
    top: 0;
    width: 12em;
    height: 1.5em;
    font-size: 0.75em;
    color: ${green400};
    line-height: 1;
    text-align: right;
  }
`;

const date = new Date();
const currentMonth = date.toLocaleString('default', { month: 'long' });
const currentYear = date.getFullYear();

const LocationsHeader = () => {
  return (
    <LocationsContainer>
      <VideaTypography variant="headingSmall" className="title">
        <Trans>Restorative Tx Metrics</Trans>
      </VideaTypography>
      <VideaTypography variant="headingSmall" className="period">
        {`${currentMonth} ${currentYear}`}
      </VideaTypography>
      <div className="info">
        <VideaTypography variant="bodyExtrasmall">
          <Trans>All locations</Trans>
        </VideaTypography>
      </div>
      <div className="fine-print">{FINE_PRINT}</div>
    </LocationsContainer>
  );
};

export default LocationsHeader;
